// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CsY5a","partners":"styles_partners__yWQ-r"};